import type { GstCopy } from "../../components/landing/gst-calculator-model"

/** Chinese words of the GST calculator (T1320). Numbers are never written here: they come from the model and engine. */
export const gstCopyZh: GstCopy = {
  modes: { add: "加 GST", remove: "拆出 GST" },
  shortcuts: [
    { keys: ["↑", "↓"], separator: "/", action: "每次调整金额 A$1" },
    { keys: ["Shift", "↑ ↓"], action: "每次调整 A$10" },
    { keys: ["Alt", "↑ ↓"], action: "每次调整 A$0.10" },
    { keys: ["←", "→"], separator: "/", action: "在“加 GST”和“拆出 GST”之间切换" },
    { keys: ["?"], action: "显示这些快捷键" },
    { keys: ["Esc"], action: "关闭这个列表" },
  ],
  yourAmount: "你的金额",
  iWantTo: "我想要",
  amountIncl: "含 GST 金额",
  amountExcl: "不含 GST 金额",
  lineLabel: (line, including) => `第 ${line} 行：${including ? "含 GST 金额" : "不含 GST 金额"}`,
  removeLine: (line) => `删除第 ${line} 行`,
  addLine: "添加一行",
  invalid: "请输入以澳元计的金额，可带分，例如 110 或 99.95。",
  invalidLine: (line) => `第 ${line} 行：请输入以澳元计的金额，可带分，例如 110 或 99.95。`,
  hintSingle: "以澳元计，可带分，例如 110 或 99.95。",
  hintMulti: "空行会被跳过。",
  headline: {
    remove: (gross) => `${gross} 中含的 GST`,
    add: (net) => `${net} 需要加的 GST`,
    invalid: "请检查你输入的金额",
    empty: "输入金额，查看 GST",
  },
  rows: { net: "不含 GST 价格", gst: "GST（10%）", gross: "含 GST 价格" },
  quickAmounts: "常用金额",
  several: (max) => `多个项目（最多 ${max} 行，每行单独四舍五入 GST，再相加）`,
  keysHint: { change: "每次调整 A$1", ten: "×10", all: "全部快捷键" },
  result: "结果",
  breakdownCaption: "GST 明细",
  roundedPerLine: "每行单独四舍五入 GST，再相加",
  copyLink: "复制本次结果的链接",
  linkCopied: "链接已复制",
  copyFailed: "复制失败，请直接复制浏览器地址栏的网址。",
  shareSingle: "分享链接只包含单个金额。",
  privacy: "在你的浏览器里计算，不会把数据发给我们。",
  disclaimer:
    "仅为估算，不构成税务建议。按标准 10% GST 计算；GST-free（免 GST）和 input-taxed（进项税免税）的销售没有需要加的 GST。",
  visual: {
    heading: "GST 是怎么算出来的",
    net: "不含 GST 价格",
    gst: "GST",
    gross: "含 GST 价格",
    total: "含 GST 总额",
    showTable: "以表格显示",
    caption: "GST 是怎么算出来的",
    columns: ["部分", "算式", "金额", "占比"],
    remove: ["GST 是总额的十一分之一", "从总额里减去它，得到不含 GST 价格"],
    add: ["乘以 1.1，得到总额", "总额减去原价，得到 GST"],
  },
}
